module.exports = __webpack_public_path__ + "bd85173c2f35cd56c47ecfa8958e1984.svg";